var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 5.332H5.333A2.646 2.646 0 002.68 7.999l-.013 16a2.657 2.657 0 002.666 2.666h21.334A2.657 2.657 0 0029.333 24v-16a2.657 2.657 0 00-2.666-2.667zm0 18.667H5.333v-8h21.334v8zm0-13.334H5.333V8h21.334v2.666z",
    fill: "#CACACA"
  })));
}
export default SvgCreditCard;